var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-6.4 -6.4 76.80 76.80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-6.4, -6.4), scale(4.8)",
    fill: "#EEEDEB",
    d: "M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45.5,
    fill: "#F4CE14",
    r: 15.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#686D76",
    points: "41 23.71 32 29 23 23.71 23 3 41 3 41 23.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2F3645",
    points: "37 3 37 26.06 32 29 27 26.06 27 3 37 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45.5,
    fill: "#f9a215",
    r: 11.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,39.43l1.21,2.11a1.26,1.26,0,0,0,.85.6l2.43.48a1.22,1.22,0,0,1,.67,2l-1.67,1.78a1.22,1.22,0,0,0-.33,1l.29,2.4a1.26,1.26,0,0,1-1.78,1.27l-2.24-1a1.3,1.3,0,0,0-1.06,0l-2.24,1a1.26,1.26,0,0,1-1.78-1.27l.29-2.4a1.22,1.22,0,0,0-.33-1l-1.67-1.78a1.22,1.22,0,0,1,.67-2l2.43-.48a1.26,1.26,0,0,0,.85-.6l1.21-2.11A1.28,1.28,0,0,1,33.1,39.43Z",
    fill: "#F4CE14"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacy);
export default __webpack_public_path__ + "static/media/legacy.14d5dfb13ba8b9bddcbb6cec8b89ed14.svg";
export { ForwardRef as ReactComponent };